import moment from 'moment'
import { api } from '../config/api'
import { getAllCustomFilteredPrograms, getAllFilteredPrograms } from '../services/EducationalProgramService'
import { getAllFilteredEphemerides, getAllFilteredKimpleFolders, getKimpleFolderAssociatedEducationalPrograms, getKimpleFolderAssociatedFolders, getKimpleFolderAssociatedResources } from '../services/KimpleFolderService'
import { getAllFilteredResources, getCustomResources } from '../services/ResourceService'
import { getAllFilteredSubtopics } from '../services/SubtopicService'
import { getAllFilteredTopics } from '../services/TopicService'
import { generateFilters } from '../utils/filters'

export const emptySearchResults = {
  ephemeride: {
    loading: true,
    data: null,
    resources: {
      loading: true,
      data: [],
      page: 0,
      totalCount: 0,
      totalPages: 0
    },
    folders: {
      loading: true,
      data: [],
      page: 0,
      totalCount: 0,
      totalPages: 0
    },
    programs: {
      loading: true,
      data: [],
      page: 0,
      totalCount: 0,
      totalPages: 0
    }
  },
  subtopic: {
    loading: true,
    data: null
  },
  resources: {
    loading: true,
    data: [],
    page: 0,
    totalCount: 0,
    totalPages: 0
  },
  programs: {
    loading: true,
    data: [],
    page: 0,
    totalCount: 0,
    totalPages: 0
  },
  folders: {
    loading: true,
    data: [],
    page: 0,
    totalCount: 0,
    totalPages: 0
  },
  topics: {
    loading: true,
    data: [],
    page: 0,
    totalCount: 0,
    totalPages: 0
  },
  subtopics: {
    loading: true,
    data: [],
    page: 0,
    totalCount: 0,
    totalPages: 0
  },
  currentEphemeride: {
    loading: true,
    data: [],
    page: 0,
    totalCount: 0,
    totalPages: 0
  }
}

export const emptySections = {
  ephemeride: {
    loading: true,
    data: [],
    page: 0,
    totalCount: 0,
    totalPages: 0
  },
  mostViewedKimpleFolders: {
    loading: true,
    data: []
  },
  lastFolders: {
    loading: true,
    data: [],
    page: 0,
    totalCount: 0,
    totalPages: 0
  },
  lastPrograms: {
    loading: true,
    data: [],
    page: 0,
    totalCount: 0,
    totalPages: 0
  },
  educationalPrograms: {
    loading: true,
    data: [],
    page: 0,
    totalCount: 0,
    totalPages: 0
  },
  resources: {
    loading: true,
    data: [],
    page: 0,
    totalCount: 0,
    totalPages: 0
  },
  latestResourcesSeen: {
    loading: true,
    data: []
  },
  mostViewedResources: {
    loading: true,
    data: []
  },
  newestResources: {
    loading: true,
    data: [],
    page: 0,
    totalCount: 0,
    totalPages: 0
  }
}

export const sections = [
  {
    name: 'ephemeride',
    service: (pageNumber = 0, pageSize = 3) => api.get('/KimpleFolderApi/GetEphemerides', { params: {
      pageNumber,
      pageSize,
      startDate: moment().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toDate()
    }
    })
  },
  {
    name: 'mostViewedKimpleFolders',
    service: (pageNumber = 0, pageSize = 4, limit = 4) => api.get('/KimpleFolderApi/GetMostViewedKimpleFolders', { params: { limit } })
  },
  {
    name: 'lastFolders',
    service: (pageNumber = 0, pageSize = 4) => api.get('/KimpleFolderApi/GetAllFiltered', { params: { pageNumber, pageSize } })
  },
  {
    name: 'educationalPrograms',
    customService: (pageNumber = 0, pageSize = 4, limit = 4) => api.get('/EducationalProgramApi/Custom', { params: { pageNumber, pageSize } })
  },
  {
    name: 'resources',
    customService: (pageNumber = 0, pageSize = 4, limit = 4) => api.get('/ResourceApi/Custom', { params: { pageNumber, pageSize } })
  },
  {
    name: 'latestResourcesSeen',
    service: (pageNumber = 0, pageSize = 4, limit = 4) => api.get('/ResourceApi/GetLastViewedResources', { params: { limit } })
  },
  {
    name: 'mostViewedResources',
    service: (pageNumber = 0, pageSize = 4, limit = 4) => api.get('/ResourceApi/GetMostViewedResources', { params: { limit } })
  },
  {
    name: 'newestResources',
    service: (pageNumber = 0, pageSize = 4, limit = 4) => api.get('/ResourceApi/Newest', { params: { pageNumber, pageSize } })
  },
  {
    name: 'lastPrograms',
    service: (pageNumber = 0, pageSize = 4) => api.get('/EducationalProgramApi/GetAllFiltered', { params: {
      pageNumber,
      pageSize,
      krea: true
    }
    })
  }
]

export const searchResultsTypes = [
  {
    name: 'resources',
    service: (pageNumber, pageSize, filters) => getAllFilteredResources(pageNumber, pageSize, filters),
    customService: (pageNumber, pageSize, filters) => getCustomResources(pageNumber, pageSize, filters)
  },
  {
    name: 'programs',
    service: (pageNumber, pageSize, filters) => getAllFilteredPrograms(pageNumber, pageSize, filters),
    customService: (pageNumber, pageSize, filters) => getAllCustomFilteredPrograms(pageNumber, pageSize, filters)
  },
  {
    name: 'folders',
    service: (pageNumber, pageSize, filters) => getAllFilteredKimpleFolders(pageNumber, pageSize, filters)
  },
  {
    name: 'topics',
    service: (pageNumber, pageSize, filters) => getAllFilteredTopics(pageNumber, pageSize, filters)
  },
  {
    name: 'subtopics',
    service: (pageNumber, pageSize, filters) => getAllFilteredSubtopics(pageNumber, pageSize, filters)
  },
  {
    name: 'currentEphemeride',
    service: (pageNumber, pageSize, filters) => getAllFilteredEphemerides(pageNumber, pageSize, filters)
  }
]

export const ephemerideContents = [
  {
    name: 'resources',
    service: ({ id, pageNumber, pageSize }) => getKimpleFolderAssociatedResources({ id, pageNumber, pageSize })
  },
  {
    name: 'programs',
    service: ({ id, pageNumber, pageSize }) => getKimpleFolderAssociatedEducationalPrograms({ id, pageNumber, pageSize })
  },
  {
    name: 'folders',
    service: ({ id, pageNumber, pageSize }) => getKimpleFolderAssociatedFolders({ id, pageNumber, pageSize })
  }
]

export const feedFilters = [
  {
    name: 'topicIds',
    service: (filters) => api.get(`AccountApi/AvailableTopics?${generateFilters(null, null, filters).toString()}`)
  },
  {
    name: 'months',
    service: (filters) => api.get(`AccountApi/AvailableMonths?${generateFilters(null, null, filters).toString()}`)
  },
  {
    name: 'skillIds',
    service: (filters) => api.get(`AccountApi/AvailableSkills?${generateFilters(null, null, filters).toString()}`)
  },
  {
    name: 'ODSIds',
    service: (filters) => api.get(`AccountApi/AvailableODS?${generateFilters(null, null, filters).toString()}`)
  },
  {
    name: 'ageRangeIds',
    service: (filters) => api.get(`AccountApi/AvailableAgeRanges?${generateFilters(null, null, filters).toString()}`)
  },
  {
    name: 'subjectIds',
    service: (filters) => api.get(`AccountApi/AvailableSubjects?${generateFilters(null, null, filters).toString()}`)
  }
]
